import { Control } from 'react-hook-form'
import type { SurveyFilters } from '../../../hooks/use-survey-list'
import { ReportFilters } from '../../QuarterlyReport/components/report-filters'

interface FiltersProps {
    control: Control<SurveyFilters>
}

const Filters: React.FC<FiltersProps> = ({ control }) => {
    return <ReportFilters control={control} />
}

export default Filters
